import React, {memo} from "../../../../__snowpack__/pkg/react.js";
import {Tooltip} from "../../../../__snowpack__/pkg/antd.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
const ProductNameWrapper = styled.div`
  .ellipsis-name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    word-break: break-all;
  }
  pre {
    white-space: pre-wrap;
    font-family: SFProText-Regular, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
      sans-serif;
  }
  .pre-all{
    max-height: 300px;
    overflow-y: auto;
  }
  .pre-name {
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: pre-wrap;
    font-family: SFProText-Regular, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
      sans-serif;
  }
`;
const TooltipWrapper = styled(Tooltip)``;
const EllipsisTooltip = memo((props) => {
  const {title, isPre = false, ...otherProps} = props;
  return /* @__PURE__ */ React.createElement(TooltipWrapper, {
    getPopupContainer: (p) => p,
    title: isPre ? /* @__PURE__ */ React.createElement("pre", {
      className: "pre-all"
    }, title) : title,
    ...otherProps
  }, /* @__PURE__ */ React.createElement(ProductNameWrapper, null, isPre ? /* @__PURE__ */ React.createElement("pre", {
    className: "pre-name"
  }, title) : /* @__PURE__ */ React.createElement("div", {
    className: "ellipsis-name"
  }, title)));
});
export default EllipsisTooltip;
